import { Avatar, AvatarGroup, CoreViewProps, Icon } from '@fold-dev/core'
import { useMemo } from 'react'
import { TbUser } from 'react-icons/tb'
import { ActionButton } from './action-button'
import { UserSelectUser } from './user-select'
import { PresenceAvatar } from './presence-avatar'

export type UserProps = {
    disabled?: boolean
    users: UserSelectUser[]
    onClick: (e) => void
} & Omit<CoreViewProps, 'onClick'>

export const Users = ({ users, disabled, onClick, ...rest }: UserProps) => {
    const { avatars, more } = useMemo(() => {
        const avatars = users.slice(0, 2)
        const more = users.length - avatars.length
        return {
            avatars,
            more: more == 0 ? '' : more,
        }
    }, [users.length, users])

    return (
        <ActionButton
            disabled={disabled}
            style={{ outlineOffset: !!users.length ? 1 : undefined }}
            className={!users.length ? 'hide' : undefined}
            border={!users.length}
            onClick={onClick}>
            {!!users.length && (
                <AvatarGroup {...rest}>
                    {avatars.map((avatar: any, index: number) => (
                        <PresenceAvatar
                            noPresence
                            size="sm"
                            name={avatar.name}
                            src={avatar.image}
                            key={avatar.image ?? index}
                            border="2px solid var(--f-common-avatar-border-color)"
                        />
                    ))}

                    {!!more && (
                        <PresenceAvatar
                            noPresence
                            size="sm"
                            name={`+ ${more}`}
                            border="2px solid var(--f-common-avatar-border-color)"
                        />
                    )}
                </AvatarGroup>
            )}

            {!users.length && (
                <Icon
                    icon={TbUser}
                    size="sm"
                />
            )}
        </ActionButton>
    )
}
